<h3>{{ field.key | translate }}</h3>
<div id="container">
  <div id="rowsContainer" cdkDropList *ngIf="rowConstrainedFields.length != 0" (cdkDropListDropped)="drop($event)">
    <ng-container *ngFor="let rowField of rowConstrainedFields; index as idx">
      <div class="row" cdkDrag [cdkDragDisabled]="!field.editable">

        <span *ngIf="field.editable" class="drag-icon">
          <mat-icon>drag_indicator</mat-icon>
        </span>

        <dynamic-cell-form [fields]="rowField" />

        <div *ngIf="field.editable"
             matTooltip="{{ 'deleteRow' | translate }}"
             matTooltipClass="big-tooltip">
          <button mat-mini-fab
                  class="deleteButton"
                  type="button"
                  (click)="deleteRow(idx)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
    </ng-container>
  </div>
  <div *ngIf="field.editable" id="addButton">

    <div matTooltip="{{ 'addNewRow' | translate }}"
         matTooltipClass="big-tooltip">
      <button mat-mini-fab
              type="button"
              (click)="addNewRow()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

  </div>
</div>
